class CategoryVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.touch = matchMedia('(hover: none), (pointer: coarse)');
    this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    this.hovered = false;
    this.visible = false;
    this.nearby = false;
    this.addEventListener('pointerenter', () => { this.hovered = true; this.update(); }, options);
    this.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, options);
    this.addEventListener('focusin', () => this.update(), options);
    this.addEventListener('focusout', () => queueMicrotask(() => this.update()), options);
    document.addEventListener('visibilitychange', () => this.update(), options);
    this.touch.addEventListener('change', () => this.update(), options);
    this.reducedMotion.addEventListener('change', () => this.update(), options);
    this.video.addEventListener('playing', () => {
      if (this.shouldPlay()) this.setAttribute('data-playing', '');
      else this.update();
    }, options);
    this.video.addEventListener('error', () => this.removeAttribute('data-playing'), options);
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
      this.update();
    }, { threshold: [0, 0.25] });
    this.observer.observe(this);
    this.preloadObserver?.disconnect();
    this.preloadObserver = new IntersectionObserver(([entry]) => {
      this.nearby = entry.isIntersecting;
      this.prepare();
    }, { rootMargin: '800px 0px' });
    this.preloadObserver.observe(this);
  }

  prepare() {
    if (this.preloaded || !this.isConnected || document.hidden || this.reducedMotion.matches
      || (!this.nearby && !this.visible)) return;
    this.preloaded = true;
    this.video.preload = 'auto';
    this.video.load();
    this.preloadObserver?.disconnect();
  }

  shouldPlay() {
    return this.isConnected && this.visible && !document.hidden && !this.reducedMotion.matches
      && (this.touch.matches || this.hovered || this.contains(document.activeElement));
  }

  update() {
    this.prepare();
    if (this.shouldPlay()) {
      this.video.muted = true;
      this.video.play().catch(() => this.removeAttribute('data-playing'));
    } else {
      this.video.pause();
      this.removeAttribute('data-playing');
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.preloadObserver?.disconnect();
    this.video?.pause();
    this.removeAttribute('data-playing');
  }
}

if (!customElements.get('category-video')) customElements.define('category-video', CategoryVideo);
